var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetiredTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.518,
    height: 22,
    viewBox: "0 0 56.518 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806",
    transform: "translate(-1192.031 -1516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(1192.1 1516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_310",
    "data-name": "Path 310",
    transform: "translate(-0.068)",
    fill: "#fbf8f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.7830924987793 21.5 L 2.734731197357178 21.5 C 1.523381114006042 21.5 0.5000011324882507 19.66822052001953 0.5000011324882507 17.5 L 0.5000011324882507 4.5 C 0.5000011324882507 2.331779956817627 1.523381114006042 0.5 2.734731197357178 0.5 L 53.7830924987793 0.5 C 54.99444198608398 0.5 56.017822265625 2.331779956817627 56.017822265625 4.5 L 56.017822265625 17.5 C 56.017822265625 19.66822052001953 54.99444198608398 21.5 53.7830924987793 21.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.734729766845703 1 C 1.915851593017578 1 1 2.496799468994141 1 4.5 L 1 17.5 C 1 19.50320053100586 1.915851593017578 21 2.734729766845703 21 L 53.7830924987793 21 C 54.60197067260742 21 55.517822265625 19.50320053100586 55.517822265625 17.5 L 55.517822265625 4.5 C 55.517822265625 2.496799468994141 54.60197067260742 1 53.7830924987793 1 L 2.734729766845703 1 M 2.734729766845703 0 L 53.7830924987793 0 C 55.29344177246094 0 56.517822265625 2.014720916748047 56.517822265625 4.5 L 56.517822265625 17.5 C 56.517822265625 19.98527908325195 55.29344177246094 22 53.7830924987793 22 L 2.734729766845703 22 C 1.224380493164062 22 0 19.98527908325195 0 17.5 L 0 4.5 C 0 2.014720916748047 1.224380493164062 0 2.734729766845703 0 Z",
    stroke: "none",
    fill: "#b47722"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Retired",
    transform: "translate(8.932 14)",
    fill: "#b47714",
    fontSize: 12,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Retired"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetiredTag);
export default __webpack_public_path__ + "static/media/retired_tag.423932bcf5e0f6a5fffcd10bf91de2cd.svg";
export { ForwardRef as ReactComponent };